import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress, rsParentCom } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseHomeClusters } from "./UseHomeClusters";
import HomeClusterFrame from "./HomeClusterFrame";

export default function Clusters(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { ProductCluster } = UseHomeClusters();
  const [clusters, setClusters] = useState();
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);

  useEffect(() => {
    setProgress(true);
    ProductCluster(location.state.ClusterID, (callback) => {
      setClusters(callback[0]);
    });
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: msParentCom.backUrl,
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: msParentCom.parentComs },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/ProductsClusterManage",
          },
        ],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
          فریم نمایش
        </Typography>
        <HomeClusterFrame
          aid={location.state.ClusterID}
          clusters={clusters && clusters}
          setClusters={setClusters}
        />
      </Box>
    </Detail>
  );
}
